import { bioAnalyticsDisabled } from './analytics-preference';
import { browserBioContext } from '@/lib/link-in-bio/analytics-context';

/** Scoped to one rendered page load, never persisted across visits. */
export function createBioCollector(slug: string) {
  // Insecure LAN previews and older browsers can lack this secure-context API.
  if (typeof globalThis.crypto?.randomUUID !== 'function') return (_blockId: string) => undefined;
  const loadId = crypto.randomUUID();
  const sent = new Set<string>();
  return (blockId: string) => {
    if (bioAnalyticsDisabled() || sent.has(blockId)) return;
    sent.add(blockId);
    const body = JSON.stringify({
      eventId: crypto.randomUUID(),
      loadId,
      blockId,
      ...browserBioContext(document.referrer, window.location.search),
    });
    const url = `/api/bio/${encodeURIComponent(slug)}/events`;
    if (blockId !== 'view' && navigator.sendBeacon) {
      try {
        if (navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }))) return;
      } catch {
        /* Fall back when the browser refuses to queue the beacon. */
      }
    }
    void fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
  };
}
